import { Copy } from 'lucide-react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import ExportEmail from '../modals/ExportEmail';
import GoBack from '../modals/GoBack';
import { useEmailContext } from 'features/email-generator/EmailGeneratorContext';

const EmailHeader = () => {
  const location = useLocation();
  const { emailContent, activeIndex } = useEmailContext();
  const handleCopy = () => {
    if (!emailContent) return;

    navigator.clipboard
      .writeText(emailContent[activeIndex])
      .finally(() => toast.success('Content copied to clipboard'));
  };

  return (
    <div className="w-full rounded-t-lg bg-background py-4 px-4 border-b-[1px] flex justify-between items-center">
      <div className="flex">
        <GoBack />
        <span className="font-bold text-2xl text-text-primary">
          Email Writer
        </span>
      </div>

      <div
        className={`gap-4 items-center cursor-pointer ${location.pathname === '/email-generator/email' ? 'flex' : 'hidden'}`}
      >
        {/* copy  */}
        <div
          className="w-8 h-8 items-center flex sm:justify-start justify-end"
          onClick={handleCopy}
        >
          <Copy size={16} color="#846CEC" />
        </div>
        <div className="sm:block hidden">
          <ExportEmail />
        </div>
      </div>
    </div>
  );
};

export default EmailHeader;
